import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { InfoBadgeComponent } from './components/info-badge/info-badge.component';
import { SharedBadgeComponent } from './components/badge/badge.component';
import { SuccessBadgeComponent } from './components/success-badge/success-badge.component';
import { LightBadgeComponent } from './components/light-badge/light-badge.component';
import { SuccessBadgeLightComponent } from './components/success-badge-light/success-badge-light.component';
import { PartyTypeBadgeComponent } from './components/party-type-badge/party-type-badge.component';
import { PartySourceBadgeComponent } from './components/party-source-badge/party-source-badge.component';
import { PartyBadgeComponent } from './components/party-badge/party-badge.component';

const COMPONENTS = [
  SharedBadgeComponent,
  InfoBadgeComponent,
  SuccessBadgeComponent,
  LightBadgeComponent,
  SuccessBadgeLightComponent,
  PartyTypeBadgeComponent,
  PartySourceBadgeComponent,
  PartyBadgeComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    NgbTooltipModule,
  ],
  exports: [...COMPONENTS],
})
export class BadgeModule { }
